// Always-visible cold-sequence send status indicator.
//
// Polls /crm/api/sequences/send-status every minute. Click → /sequences/queue
// for the full outbox + pause/resume controls. Hidden if the API doesn't
// respond so the shell stays clean instead of flashing a fake "paused" state.

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { campaignsApi } from "@/lib/api";
import { cn } from "@/lib/utils";

export default function SendStatusPill() {
  const { data, error } = useQuery({
    queryKey: ["sequences", "send-status"],
    queryFn: () => campaignsApi.sequencesSendStatus(),
    refetchInterval: 60_000,
    retry: 1,
  });

  if (error || !data) return null;

  const paused = data.effective_paused;
  return (
    <Link
      to="/sequences/queue"
      title={
        paused
          ? "Cold sequences paused — click to view the queue + resume"
          : "Cold sequences live — click to view the queue"
      }
      className={cn(
        "hidden items-center gap-1.5 rounded-full px-2 py-1 text-xs font-semibold transition-colors duration-[120ms] ease-lz sm:inline-flex",
        paused
          ? "bg-warn-soft text-warn hover:bg-warn/25"
          : "bg-success-soft text-success hover:bg-success/20",
      )}
    >
      <span
        aria-hidden
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          paused ? "bg-warn" : "bg-success animate-pulse",
        )}
      />
      <span>{paused ? "Paused" : "Sending"}</span>
    </Link>
  );
}
